<template>
  <div class="kpt-group-detail" v-if="group && !isLoading">
    <vue-headful :title="title" />
    <header class="kpt-detail-pane-header">
      <h4>
        <b-tooltip label="Refreshing..." v-if="isRefreshing">
          <font-awesome-icon :icon="['far', 'spinner-third']" spin />
        </b-tooltip>
        <font-awesome-icon :icon="['far', 'object-group']" v-else />
        <span>{{group.name}}</span>
      </h4>
      <div class="page-control block">
        <font-awesome-icon :icon="['far', 'times-circle']" size="lg" @click="close" title="Close" />
      </div>
    </header>
    <div class="kpt-detail-main">
      <div class="kpt-detail-nav">
        <header>
          <h6 class="is-uppercase"><strong>General</strong></h6>
        </header>
        <ul>
          <router-link 
          tag="li" 
          :to="{ name: 'groupOverview' }" 
          ref="groupOverview"
          active-class="is-active"
          :keywords="['overview']">
            <a>
              <font-awesome-icon :icon="['far', 'file-chart-line']" />
              <span>Overview</span>
            </a>
          </router-link>
        </ul>
      </div>
      <div class="kpt-detail-content">
        <router-view></router-view>
      </div>
    </div>
  </div>
  <div v-else-if="!group && !isLoading && notFound">
    <vue-headful title="Group Not Found" />
    <header class="kpt-detail-pane-header">
      <h4>
        <span>Group Not Found</span>
      </h4>
      <div class="page-control block">
        <font-awesome-icon :icon="['far', 'times-circle']" size="lg" @click="close" title="Close" />
      </div>
    </header>
    <div class="kpt-detail-main">
      <div class="kpt-detail-content" style="padding: 12px">
        <p>This group does not exist or you don't have the permission to view this group. If you've arrived here via a hotlink, please report this to Kymeta.</p>
        <br>
        <p>Go to the <a @click="close">groups list</a> page.</p>
      </div>
    </div>
  </div>
  <div class="kpt-detail-loading" v-else>
    <b-loading :is-full-page="false" :active.sync="isLoading" :can-cancel="false"></b-loading>
  </div>
</template>
<script>

export default {
  data() {
    return {
      notFound: false
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.id != from.params.id) {
      this.$store.dispatch('fetchGroup', to.params.id);
    }
    next();
  },
  async created() {
    if (this.$route.params.id != 'create') {
      await this.$store.dispatch('fetchGroup', this.$route.params.id);
      if (!this.group) {
        this.notFound = true;
      }
    }
  },
  computed: {
    group() {
      return this.$store.state.groups.group;
    },
    isLoading() {
      return this.$store.state.groups.isLoadingGroup;
    },
    isRefreshing() {
      return this.$store.state.groups.isRefreshingGroup;
    },
    title() {
      return `Group - ${this.group.name}`;
    }
  },
  methods: {
    close() {
      this.$router.push({ path: '/groups' });
    }
  }
}
</script>
<style lang="scss" scoped>
.kpt-group-detail {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
